
import api_list from "@/constant/apiUrl";
import app_config from "@/constant/config";
import { startRequest } from "@/utility/helper/requestHelper";

export const getFaqTopics = async (params:any) => {
  const apiData = {
    url: api_list.faq,
    method: "GET",
    params: {
      ...params
    }
  };

  return startRequest(apiData, app_config.api_static);
};
 

export const getFaqByTopic = async (params:any) => {
  const apiData = {
    url: api_list.faq + `/${params.id}`,
    method: "GET",
    params: {
      ...params
    }
  };

  return startRequest(apiData, app_config.api_static);
};
 
export const getDetailFaqList = async (params:any) => {
  const apiData = {
    url: api_list.faqDetail + `/${params.id}`,
    method: "GET",
    params: {
      ...params
    }
  };

  return startRequest(apiData, app_config.api_static);
};